'use strict';
import React from 'react';
import RequestListingItem from './requestsListingItem';

var RequestListing = React.createClass({
    displayName: 'RequestListing',
    mixins: [],
    propTypes: {},
    render() {
        return (
            <div className="request__listing">
                {this.props.requests.map( ( item, ix ) => <RequestListingItem key={ix} item={item} /> )}
            </div>
        );
    }
});

module.exports = RequestListing;



// WEBPACK FOOTER //
// ./app/pages/licensing/requests/requestsListing.jsx